import { ITranslationItem, ITranslationItems } from './language.types';

interface CheckboxTranslation {
  label: ITranslationItem;
  errorLabel: ITranslationItem;
}

export const stepHeaderCounterLabel = (
  currentStep?: number,
  maxSteps?: number
): ITranslationItems => ({
  counter: {
    nl: `Stap ${currentStep} van ${maxSteps}`,
    en: `Step ${currentStep} of ${maxSteps}`,
  },
});

export const TEXT_AREA_TRANSLATIONS: CheckboxTranslation = {
  label: {
    nl: 'Vul hier je antwoord in',
    en: 'Enter your answer here',
  },
  errorLabel: {
    nl: 'Dit veld is verplicht',
    en: 'This field is required',
  },
};

export const ARTICLE_RESULTS: ITranslationItems = {
  title: {
    nl: 'Voor jouw sector',
    en: 'For your industry',
  },
};
